// extracted by mini-css-extract-plugin
module.exports = {"description":"ItemAndDescription_description__zDsc_"};